import React from 'react'
import { Link } from "react-router-dom";
import "./Header.css"
export default function Navbar() {
  return (
    <header className="header">
      <div className="header-container">
        {/* Logo + Title */}
        <div className="logo-title">
          <div className="logo-box">A</div>
          <div>
            <div className="title">AdvocatePro</div>
            <div className="subtitle">Case & Client Manager</div>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="nav">
          <a href="#Home">Home</a>
          <a href="#features">Features</a>
          <a href="#how">How it works</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact">Contact</a>
          <Link to="/login">
          <button className="btn-outline">Login</button>
          </Link>
          <Link to="/register">
          <button className="btn-outline">Register</button>
          </Link>
          {/* <button className="btn-primary">Get Started</button> */}
        </nav>

        {/* Mobile Menu Button */}
        <div className="mobile-menu">
          <button>☰</button>
        </div>
      </div>
    </header>
  )
}